export const settings = {
  setupProgam: 'http://tsplus.mx/descargas2020/Setup-TSplus-ES.exe',
  updateReleasePatch: 'http://tsplus.mx/descargas2020/UpdateRelease.exe',
  ultimateProtection: 'http://tsplus.mx/descargas2020/Setup-TSplus-Security.exe',
  serverMonitoring: 'http://tsplus.mx/descargas2020/Setup-Agent.exe',
  appleApp: 'https://itunes.apple.com/us/app/tsplus/id1346566246',
  androidApp: 'https://play.google.com/store/apps/details?id=com.terminalserviceplus.mobile',
  microsoftApp: 'http://tsplus.mx/descargas2020/Setup-TSplusApp.exe'
}
